import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { getEntityApiKeyToastErrorMessage } from "@entity-api-keys/domain/utils/entity-api-key-toast-error-message";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteEntityApiKeyUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(id: number): Promise<boolean> {
        const result = await this.repository.delete(id);

        if (result.isLeft()) {
            ToastManagerStore.error(
                getEntityApiKeyToastErrorMessage(result.getLeftOrThrow()),
            );
            return false;
        }

        ToastManagerStore.success();
        return true;
    }
}
